import { COOKIE_KEYS } from "../../constants/app-constants";
import parseCookie from "./parse-cookie";
import saveCookie from "./save-cookie";
import deleteCookie from "./delete-cookie";

const TOKEN_EXPIRY_MULTIPLIER = 1000;

export const ACCESS_TOKEN_COOKIE_NAMES = [
    COOKIE_KEYS.TOKEN,
    COOKIE_KEYS.LEGACY_TOKEN,
    COOKIE_KEYS.WEB_TOKEN
];

export const REFRESH_TOKEN_COOKIE_NAMES = [
    COOKIE_KEYS.REFRESH_TOKEN,
    COOKIE_KEYS.LEGACY_REFRESH_TOKEN
];

export const getAccessTokenFromBrowserCookies = () => {
    for (const cookieName of ACCESS_TOKEN_COOKIE_NAMES) {
        const token = parseCookie(cookieName);
        if (token) return token;
    }

    return "";
};

export const getAccessTokenFromRequestCookies = (cookies = {}) => {
    for (const cookieName of ACCESS_TOKEN_COOKIE_NAMES) {
        if (cookies[cookieName]) return cookies[cookieName];
    }

    return "";
};

export const getAuthCookieDomain = () => {
    if (typeof window !== "undefined") {
        const hostname = window.location.hostname;

        if (hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) return "";
        if (hostname.includes("cars24.com.au")) return ".cars24.com.au";
        if (hostname.includes("qac24svc.dev")) return ".qac24svc.dev";
        if (hostname.includes("c24.tech")) return ".c24.tech";
    }

    const hostEnv = process.env.HOST_ENV;
    const domains = {
        LOCAL: "",
        QA: ".qac24svc.dev",
        STAGING: ".qac24svc.dev",
        LNOD: ".qac24svc.dev",
        PRODUCTION: ".cars24.com.au"
    };

    return domains[hostEnv] || "";
};

export const saveBifrostAuthCookies = ({
    accessToken,
    refreshToken = "",
    sessionId = "",
    expiresIn,
    persistLegacyToken = true
} = {}) => {
    if (!accessToken) return;

    const cookieDomain = getAuthCookieDomain();
    saveCookie(COOKIE_KEYS.TOKEN, accessToken, 1, cookieDomain);

    if (persistLegacyToken) {
        saveCookie(COOKIE_KEYS.LEGACY_TOKEN, accessToken, 1, cookieDomain);
    }

    if (refreshToken) {
        saveCookie(COOKIE_KEYS.REFRESH_TOKEN, refreshToken, 1, cookieDomain);
        saveCookie(COOKIE_KEYS.LEGACY_REFRESH_TOKEN, refreshToken, 1, cookieDomain);
    }

    if (sessionId) {
        saveCookie("bifrost_session_id", sessionId, 1, cookieDomain);
    }

    if (expiresIn) {
        saveCookie("tokenExpiry", (Date.now() + (expiresIn * TOKEN_EXPIRY_MULTIPLIER)).toString(), 1, cookieDomain);
    }
};

export const clearBifrostAuthCookies = () => {
    const cookieDomain = getAuthCookieDomain();
    [
        COOKIE_KEYS.TOKEN,
        COOKIE_KEYS.REFRESH_TOKEN,
        COOKIE_KEYS.LEGACY_TOKEN,
        COOKIE_KEYS.LEGACY_REFRESH_TOKEN,
        COOKIE_KEYS.WEB_TOKEN,
        "bifrost_session_id",
        "bifrost_device_id",
        "tokenExpiry"
    ].forEach((cookieName) => deleteCookie(cookieName, cookieDomain));
};
